import type { IconName } from '@chessmate/ui';
import { usePlayerLookStore } from '../../state/player-look-store.js';
import { useSeatPersonas } from '../../state/seat-personas.js';

export interface SeatIdentity {
  readonly name: string;
  readonly tag?: string;
  readonly portrait: string | null;
  readonly fallbackIcon: IconName;
  readonly you: boolean;
}

/**
 * Who each seat is: the player's chosen name and buddy for their own seat (South), a distinct
 * character with a portrait for every other. `seatName` turns a seat id into its words ("West").
 */
export function useSeatIdentity(seats: readonly string[], seatName: (seat: string) => string, humanSeat = 'S') {
  const look = usePlayerLookStore();
  const personas = useSeatPersonas(seats);
  return (seat: string): SeatIdentity => {
    if (seat === humanSeat) {
      return { name: look.name || seatName(seat), tag: look.name ? seatName(seat) : undefined, portrait: null, fallbackIcon: look.buddy, you: true };
    }
    const p = personas[seat];
    return { name: p?.name ?? seatName(seat), tag: seatName(seat), portrait: p?.portrait ?? null, fallbackIcon: 'Bot', you: false };
  };
}
